import type { ReactNode } from 'react';

export const symbol_vacuum_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-492q-12 0-21-8.5t-9-21.5q0-12 9-21t21-9q13 0 21.5 9t8.5 21q0 13-8.5 21.5T480-492Zm-69 207-71 70q32 17 67 26t73 9q38 0 73.5-9t67.5-26l-70-70H411Zm69-495q-62 0-116.5 23.5t-95.5 64Q227-652 203.5-597T180-480q0 69 29.5 129T289-249l75-74q-36-27-57.5-68T285-480q0-81 57-138t138-57q81 0 138 57t57 138q0 48-21.5 88.5T596-324l75 74q50-42 79.5-101.5T780-480q0-62-23.5-117t-64-95.5Q652-733 597-756.5T480-780Zm0 165q-56 0-95.5 39T345-480q0 56 39.5 95.5T480-345q57 0 96-39.5t39-95.5q0-57-39-96t-96-39Zm0 495q-74 0-139.5-28.5T226-226q-49-49-77.5-114.5T120-480q0-75 28.5-140.5t77.5-114q49-48.5 114.5-77T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 74-28.5 139.5t-77 114.5q-48.5 49-114 77.5T480-120Z"
		/>
	</svg>
);
